export const DESCRIPTION_ERROR_TEXT = 'Enter scope title';
